<template>
  <Evaluasi halaman="evaluasi2" />
</template>

<script>
import Evaluasi from '../components/Evaluasi'

export default {
  components: {
    Evaluasi
  }
}
</script>

